module.exports = __webpack_public_path__ + "static/anna2-b7beeae4f499a92ad86bd0284335d3f6.png";